// This page is for register secret question - answer After sign up using
attorney number and email.
<template>
  <main id="main-content" class="flex items-center min-h-screen w-full">
    <div
      class="w-full bg-white rounded shadow-lg p-8 m-4 md:max-w-md md:mx-auto"
    >
      <div class="md:flex w-full">
        <div class="w-full py-10 px-5">
          <div class="flex items-center gap-2 text-primary">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              ></path>
            </svg>
            <h1 class="text-right text-xl text-primary">
              Change User Settings
            </h1>
          </div>
          <form class="mt-4 space-y-6" @submit.prevent="register" novalidate>
            <div class="rounded-sm">
              <div class="flex flex-col">
                <label
                  id="secret_question_label"
                  class="block text-sm font-medium text-gray-900"
                  for="secret_question"
                  >Secret Question
                </label>
                <select
                  id="secret_question"
                  class="mt-1 block w-full h-10 border border-barley rounded-sm shadow-sm py-2 px-3 focus:outline-none sm:text-sm"
                  :class="{ 'border-red-400': v$.form.secret_question.$error }"
                  :value="form.secret_question?.name || ''"
                  aria-required="true"
                  @change="onSecretQuestionChange"
                >
                  <option value="">Select</option>
                  <option
                    v-for="item in secret_questions"
                    :key="item.id"
                    :value="item.name"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.secret_question.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="secret_answer"
                  label="Secret Answer"
                  :class="{ 'border-red-400': v$.form.secret_answer.$error }"
                  v-bind:value="form.secret_answer"
                  @blur="v$.form.secret_answer.$touch()"
                  v-on:keyup="form.secret_answer = $event.target['value']"
                ></text-input>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.secret_answer.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="old_password"
                  label="Old Password"
                  :type="show2 ? 'password' : 'text'"
                  showIcon="true"
                  showIcon1="true"
                  @showHide="show2 = !show2"
                  :class="{ 'border-red-400': v$.form.old_password.$error }"
                  v-bind:value="form.old_password"
                  @blur="v$.form.old_password.$touch()"
                  v-on:keyup="form.old_password = $event.target['value']"
                ></text-input>

                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.old_password.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="password"
                  label="New Password"
                  :type="show ? 'password' : 'text'"
                  showIcon="true"
                  showIcon1="true"
                  @showHide="show = !show"
                  :class="{ 'border-red-400': v$.form.password.$error }"
                  v-bind:value="form.password"
                  @blur="v$.form.password.$touch()"
                  helptext="Must be at least 8 characters and contain a lowercase & uppercase character with a special character and a number."
                  v-on:keyup="form.password = $event.target['value']"
                ></text-input>

                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.password.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'password'">
                    Please enter valid password
                  </div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="confirm_password"
                  label="Confirm Password"
                  :type="show1 ? 'password' : 'text'"
                  showIcon="true"
                  showIcon1="true"
                  @showHide="show1 = !show1"
                  @blur="v$.form.confirm_password.$touch()"
                  :class="{ 'border-red-400': v$.form.confirm_password.$error }"
                  v-bind:value="form.confirm_password"
                  v-on:keyup="form.confirm_password = $event.target['value']"
                ></text-input>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.confirm_password.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'sameAsPassword'">
                    Passwords must match
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-5">
          <div class="flex justify-left">
            <button
              type="submit"
              class="inline-flex justify-center py-2 px-14 border border-transparent shadow-sm text-sm font-medium rounded-md text-white cobalt-button-color hover:!bg-[#A63A1D] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
             Update
            </button>
               <div class="mt-3 sm:mt-0 sm:ml-4">
              <router-link
                to="/home"
                type="button"
                class="inline-flex items-center px-14 py-2 border border-[#ba4224] rounded-md shadow-sm text-sm font-medium text-[#1f3341] bg-[#ffffff]"
              >
                Cancel
              </router-link>
            </div>
            </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TextInput from "../Layout/Form/TextInput.vue";
import useVuelidate from "@vuelidate/core";
import { required, sameAs } from "@vuelidate/validators";
import { helpers } from "vuelidate/lib/validators";
const password = helpers.regex(
  "password",
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
);
import { mapState } from "vuex";
export default {
  name: "Change Settings",
  components: {
    TextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  computed: mapState(["att_user", "profile_data"]),
  data: function() {
    return {
      show: true,
      show2: true,
      secret_questions: [
        { id: 0, name: "In what town or city were you born?" },
        { id: 1, name: "What was your high school mascot?" },
        { id: 2, name: "What is your mother’s maiden name?" },
        { id: 3, name: "What is your father’s middle name?" },
        {
          id: 4,
          name: "In what city or town did you meet your spouse/partner?",
        },
      ],
      show1: true,
      form: {},
    };
  },
  validations() {
    return {
      form: {
        secret_question: {
          required,
        },
        secret_answer: {
          required,
        },
        old_password: {
          required,
        },
        password: {
          required,
          password,
        },
        confirm_password: {
          required,
          sameAsPassword: sameAs(this.form.password),
        },
      },
    };
  },
   created() {
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        if (value!=null) {
          if(value.message=='Authorization failed'){
             this.$toast.error("Authorization Token Expired, Please login again!");
             this.$store.dispatch("logout");
              setTimeout(() => {
                //test
              this.$router.push({name:'Login'});
            }, 500);
          }
        }
      }
    );
   },
  mounted() {
    this.$store.dispatch("getAttProfileData");
    this.secret_questions.forEach((element) => {
      if (element.name == this.profile_data.secret_question) {
        this.form.secret_question = element;
      }
    });
    this.form.secret_answer = this.profile_data.secret_answer;
  },
  methods: {
    onSecretQuestionChange(event) {
      const name = event.target.value;
      this.form.secret_question =
        this.secret_questions.find((item) => item.name === name) || null;
      this.v$.form.secret_question.$touch();
    },
    register: function() {
      this.v$.form.$touch(this.v$.form.errors);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.form.id = this.att_user["data"].id;

      this.$store
        .dispatch("changeUserSettings", this.form)
        .then((result) => {
          if (result.data.status == "success") {
            this.$toast.success("Settings changed successfully");
            this.form.password="";
            this.form.old_password="";
            this.form.confirm_password="";
            this.v$.$reset();
          } else {
            this.$toast.error("Old password is incorrect, Please try again!");
          }
        })
        .catch((error) => {
          if (error.status == "Failed") {
            this.$toast.error(
              "Authorization Token Expired, Please login again!"
            );
            this.$store.dispatch("logout");
            this.$router.push("login");
          } else {
            this.$toast.error("Old password is incorrect, Please try again!");
          }
          console.log("error: ", error);
        });
    },
  },
};
</script>
